import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import Userpause from '../../../src/assests/images/user-tick.svg';
interface PauseAccountPopupProps {
    open: boolean;
    handleClose: () => void;
}

const PauseAccountPopup: React.FC<PauseAccountPopupProps> = ({ open, handleClose }) => {
    return (

        <Dialog open={open} maxWidth="xs" fullWidth PaperProps={{
            sx: {
                borderRadius: '16px',
                backgroundColor: '#FFF5E5', // soft beige background
                textAlign: 'center',
                padding: '24px',
                maxWidth: "584px"
            }
        }}>
            <DialogContent>
                {/* Circle Icon Section */}
                <Box
                    sx={{
                        backgroundColor: '#FFD247', // yellow circle background
                        borderRadius: '50%',
                        width: 100,
                        height: 100,
                        margin: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'relative',
                        mb: 4
                    }}
                >
                    <img src={Userpause} alt="pause Account" />
                </Box>

                {/* Title */}
                <Typography sx={{ fontSize: '14px', fontWeight: "500", color: '#D79304', mb: 1 }}>
                    ⓘ Profile Update
                </Typography>

                {/* Message */}
                <Typography sx={{ fontSize: '18px', color: '#494A4B' }}>
                    Your profile is paused. You cannot access any modules or perform any activities. Admin will notify you once your profile is resumed.
                </Typography>
            </DialogContent>
        </Dialog>
    );
};

export default PauseAccountPopup;